// extracted by mini-css-extract-plugin
export default {"bg":"styles_bg__-otw-","section":"styles_section__PB0OH","ttl":"styles_ttl__jj+kk","txt":"styles_txt__hB9Py","cardSec":"styles_cardSec__5UwQy"};